module.exports = __webpack_public_path__ + "static/egyptian-bedding-set-white-4-91ed98762695f9f129eb9a242c1ab65a.png";